/* eslint-disable  */
/* eslint-disable operator-linebreak */
import React, { useState, useEffect } from 'react';

import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';
import {
  CardContentContainer,
  CardContentTitle,
  CardImgContainer,
  CardContainer,
  FallbackImg,
  CardContentSubtitle,
  CardFooterTag,
  CardUserActionTag,
  CardAdminActionTag,
  CardActionButtonsContainer,
  ApproveButton,
  DeclineButton,
} from './styles';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';

enum BenefitActionType {
  CREATE = 'added',
  REMOVE = 'removed',
}

const Card: React.FC<{
  imgURL: string;
  title: string;
  subtitle: string;
  tag: string;
  approved: boolean;
  price?: number;
  alreadyApproved?: boolean;
  beneficiaries?: string;
  dependents?: string;
  approvalStatus?: string;
  onClick?: (approved: boolean) => void;
}> = ({
  imgURL,
  title,
  subtitle,
  tag,
  approved,
  price,
  onClick,
  alreadyApproved,
  beneficiaries,
  dependents,
  approvalStatus,
}) => {
  // Default to approved (true) unless explicitly declined
  const [approvedState, setApproved] = useState<boolean>(() => {
    if (approvalStatus === 'declined') return false;
    if (approvalStatus === 'approved') return true;
    return true; // Default to approved
  });

  useEffect(() => {
    // Use approvalStatus when available, default to approved
    if (approvalStatus === 'declined') {
      setApproved(false);
    } else if (approvalStatus === 'approved') {
      setApproved(true);
    } else {
      // Default to approved for pending or no status
      setApproved(true);
    }
  }, [approved, approvalStatus]);

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = fallbackImageUrl;
  };

  const handleApprove = () => {
    if (!alreadyApproved && (!approvalStatus || approvalStatus === 'to_approve')) {
      setApproved(true);
      if (onClick) {
        onClick(true);
      }
    }
  };

  const handleDecline = () => {
    if (!alreadyApproved && (!approvalStatus || approvalStatus === 'to_approve')) {
      setApproved(false);
      if (onClick) {
        onClick(false);
      }
    }
  };

  const getBiWeeklyCost = (price: number) => {
    if (price > 0) return price;
    return 0;
  };

  return (
    <CardContainer data-testid="card-container">
      <CardContentContainer>
        <CardContentTitle>{title}</CardContentTitle>
        <CardContentSubtitle>{subtitle}</CardContentSubtitle>
        <CardContentSubtitle>
          {price !== null && price !== undefined
            ? `Bi-weekly Cost: ${monetaryUSDFormat(getBiWeeklyCost(price))}`
            : `Cost: ${monetaryUSDFormat(0)}`}
        </CardContentSubtitle>
        <CardContentSubtitle>{beneficiaries ? `Beneficiaries: ${beneficiaries}` : ''}</CardContentSubtitle>
        <CardContentSubtitle>{dependents ? `Dependents: ${dependents}` : ''}</CardContentSubtitle>
        <CardFooterTag>
          <CardUserActionTag
            style={{
              color: tag === BenefitActionType.CREATE ? 'green' : '#FF0000',
            }}
          >
            {tag}
          </CardUserActionTag>

          {!alreadyApproved && (!approvalStatus || approvalStatus === 'to_approve') ? (
            <CardActionButtonsContainer>
              <ApproveButton onClick={handleApprove} isActive={approvedState}>
                APPROVE
              </ApproveButton>
              <DeclineButton onClick={handleDecline} isActive={!approvedState}>
                DECLINE
              </DeclineButton>
            </CardActionButtonsContainer>
          ) : (
            <CardAdminActionTag
              style={{
                color: approvedState ? 'green' : '#FF0000',
                border: approvedState ? '1px solid green' : '1px solid #FF0000',
                cursor: 'default',
              }}
            >
              {approvalStatus ? approvalStatus.toUpperCase() : approvedState ? 'APPROVED' : 'DECLINED'}
            </CardAdminActionTag>
          )}
        </CardFooterTag>
      </CardContentContainer>
    </CardContainer>
  );
};

export default Card;
